<ion-header>
  <ion-toolbar>
    <ion-title [innerHTML]="'ACTIONS.MULTIPLE_ACTIONS' | translate"></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="multi-action__item --choose" (click)="addAction()">
    <div class="multi-action__item__description">
      <span class="multi-action__item__description__text">
        <span [innerHTML]="'ACTIONS.ADD_NEW_ACTION_TO_STACK' | translate"></span>
      </span>
    </div>
  </div>

  <ng-container *ngFor="let action of (chanceNodeId | toChanceNode | async) | getActions:reason; let last=last">
    <div class="multi-action__item" (click)="editAction(action)">
      <div class="multi-action__item__type">
        <img class="multi-action__item__type__icon" src="assets/scenarios/action.svg" />
        <span class="multi-action__item__type__text" [innerHTML]="'SCENARIOS.ACTION' | translate"></span>
      </div>
      <div class="multi-action__item__description">
        <span
          class="multi-action__item__description__title"
          [innerHTML]="'ACTIONS.' + (action.actionId | toAction | async)?.name | translate"
        ></span>
        <span
          class="multi-action__item__description__text"
          [innerHTML]="action | actionDescription :(action.actionId | toAction | async)"
        ></span>
      </div>
    </div>
    <span class="multi-action__connection" *ngIf="!last"></span>
  </ng-container>
</ion-content>

<ion-footer>
  <ion-button class="button --small --dark-outline" [innerHTML]="'BUTTONS.CANCEL' | translate" (click)="dismiss()"></ion-button>
</ion-footer>
